import React from 'react'

const Symptom = () => {
  return (
    <div id="symptom-identification" className="page">
        <div id="symptom-card">
            <div id="symptom-card-header">
                <h3>SYMPTOM ANALYSIS</h3>
            </div>
            <div id="analysis-results">
                <img id="graph" src='https://cdn.discordapp.com/attachments/934079930583625750/965265257088057416/unknown.png' alt="sym-img" />
            </div>
        </div>
        <div id="symptom-page-image">
            <img id="symp-img" src="/images/8.png" alt="sym-img" />
        </div>
    </div>
  )
}

export default Symptom